import { Button, Empty, notification, Result, Spin } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import useFormatApiRequest from "../../hooks/formatApiRequest";
import { useAppDispatch } from "../../Redux/reduxCustomHook";
import { ILoadState } from "../../utils/loading.utils.";
import "./User-Profile-Comp.css";
import UserTransactionsDetailsCard from "./UserTransactionsDetailCard";
import { sampleApiCall } from "../../apiservice/authService";
import { userGetTransactionSingle } from "../../apiservice/userService";
type NotificationType = "success" | "info" | "warning" | "error";

export const UserTransactionsDetailsComp = () => {
  const [propsLoadState, setPropsLoadState] = useState<ILoadState>("loading");
  const [loadpropsData, setLoadPropsData] = useState(true);
  const [transactionDataData, setTransactionDataData] =
    useState<any | null>(null);
  const [api, contextHolder] = notification.useNotification();

  // For Navigator/Redux
  const dispatch = useAppDispatch();
  const params = useParams();

  // A custom hook to Load All props Details
  const propsDataResult = useFormatApiRequest(
    () => userGetTransactionSingle(params?.id || 0),
    loadpropsData,
    () => {
      setLoadPropsData(false);
    },
    () => {
      processpropsResult();
    }
  );

  // Process The Current Props Data Result
  const processpropsResult = async () => {
    if (propsDataResult.httpState === "SUCCESS") {
      setTransactionDataData(propsDataResult.data?.data);
      setPropsLoadState("completed");
    } else if (propsDataResult.httpState === "ERROR") {
      setPropsLoadState("error");
    } else if (propsDataResult.httpState === "LOADING") {
      setPropsLoadState("loading");
    }
  };

  // Show Notification
  const openNotificationWithIcon = (
    type: NotificationType,
    message: string,
    description: string,
    background?: string
  ) => {
    api[type]({
      message,
      description,
      placement: "bottomRight",
      style: { background },
    });
  };

  return (
    <>
      {/* " The context is use to hold the notification from ant design" */}
      {contextHolder}
      <div className="grid p-4">
        {/* " Show Loading Indicator" */}
        {propsLoadState === "loading" && (
          <div className="mt-2 mb-2 flex justify-center items-center pt-20 pb-20">
            <Spin size="large" />
          </div>
        )}

        {/* " Show Loading Error" */}
        {propsLoadState === "error" && (
          <div className="mt-2 mb-2">
            <Result
              status="500"
              title={<span className="text-gray-900 dark:text-stone-100">Error</span>}
              subTitle={
                <span className="text-gray-600 dark:text-stone-400">
                  Sorry, something went wrong, it could be a network Related
                  error
                </span>
              }
              extra={
                <Button onClick={() => setLoadPropsData(true)} type="primary">
                  Reload
                </Button>
              }
            />
          </div>
        )}

        {/* " Show No data" */}
        {propsLoadState === "noData" && (
          <div className="mt-2">
            <Empty></Empty>
          </div>
        )}

        {/* " Show Data " */}
        {propsLoadState === "completed" && (
          <div>
            <UserTransactionsDetailsCard
              transactionDetailsData={transactionDataData}
            ></UserTransactionsDetailsCard>
          </div>
        )}
      </div>
    </>
  );
};
